"use strict";
// This file holds types that are common to the domain-specific APIs.
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiVersion = void 0;
exports.apiVersion = "v1alpha2";
